import Mapper from './Mapper';
import { PriceAnyResponseDTO } from 'typings/dto/price';

export default class PriceTechnicianMapper extends Mapper<Price.Technician, PriceAnyResponseDTO.Technician> {
  constructor() {
    super(
      {
        currency: 'currency',
        owner: 'owner',
        region: 'region',
        serviceItem: 'service',
        attributes: 'attributes',
        catalogPrice: 'clientValue',
        clientPrice: 'clientPrice',
        type: 'type',
        promotion: 'promotion',
        productPrice: 'productPrice',
      }
    );
  }

  public responseDTOToModel(dto: PriceAnyResponseDTO.Technician): Price.Technician {
    return {
      ...(this.getOuterMappers().priceAny.responseDTOToModel(dto) as Price.Technician),
    };
  }

  public responseDTOToModelIdAndNamesOnly = (dto: PriceAnyResponseDTO.Technician): Price.Technician => {
    return this.responseDTOToModel(dto);
  };
}
